// telas/Espera.tsx - A espera da dinâmica (07_VOZ §5; D78, D80; mockup do celular, estado 2).
//
// Etapas na língua do professor, por tempo estimado (a geração não informa progresso), o tempo que falta,
// uma dica útil e o aviso de ficar na tela. A tela acesa e a confirmação ao sair ficam em useEspera.

import { IconSmartphone, WaitProgress } from '@winieduca/ui';
import { espera, esperaNovos } from '../content/textos';

/** Tempo típico da geração (P42: cerca de 45 segundos; o texto aprovado diz "cerca de 1 minuto"). */
export const TEMPO_ESTIMADO = 60;

/** Etapa atual e progresso, pelo tempo decorrido. Passado o estimado, fica na última etapa, quase cheia. */
export function progressoDaEspera(segundos: number, etapas = espera.etapas.length) {
  const fracao = Math.min(segundos / TEMPO_ESTIMADO, 0.95);
  const atual = Math.min(Math.floor((segundos / TEMPO_ESTIMADO) * etapas), etapas - 1);
  const faltam = Math.max(0, TEMPO_ESTIMADO - segundos);
  // Arredondado de 5 em 5: "uns 25 segundos", sem contagem nervosa.
  const faltamArredondado = Math.max(5, Math.ceil(faltam / 5) * 5);
  return { valor: fracao * 100, atual, faltam, faltamArredondado, passouDoTempo: segundos > TEMPO_ESTIMADO + 15 };
}

export function Espera({ segundos }: { segundos: number }) {
  const p = progressoDaEspera(segundos);
  const tempo = p.passouDoTempo ? esperaNovos.demorando : p.faltam > 0 ? esperaNovos.faltam(p.faltamArredondado) : esperaNovos.quase;
  return (
    <section className="din-espera" aria-labelledby="espera-titulo">
      <header className="din-abertura">
        <h1 id="espera-titulo" className="we-display din-titulo" tabIndex={-1}>
          {espera.titulo}
        </h1>
        <p className="we-lead din-subtitulo">{espera.tempo}</p>
      </header>
      {/* Sem anúncio a cada mudança: a barra já diz a etapa ao leitor de tela. */}
      <p className="din-espera__tempo">{tempo}</p>
      <WaitProgress label={espera.titulo} value={p.valor} stages={espera.etapas} current={p.atual} />
      <section className="din-dica" aria-labelledby="dica-titulo">
        <h2 id="dica-titulo" className="din-dica__titulo">
          {esperaNovos.enquantoIsso}
        </h2>
        <p className="din-dica__texto">{esperaNovos.dica}</p>
      </section>
      <p className="din-fique">
        <IconSmartphone className="din-fique__icone" />
        <span>{espera.fique}</span>
      </p>
    </section>
  );
}
